<div class="section-gap" *ngIf="hasApplications">
  <div class="draft-title draft-title-typography">Draft Applications</div>
  <ng-contaner *ngIf="!loadingComplete" class="spinner-div">
      <mat-spinner class="spinner-cls"></mat-spinner>
  </ng-contaner>
  <ng-container *ngIf="!isMobileDeviceSize;else mobileDrafts">
    <div class="draft-applications-table-container">
      <table id="draftApplicationsTable" class="draft-applications-table" matSort (matSortChange)="sortChangeUpdate($event)">
        <caption>
            <mat-paginator
                [length]="totalItems"
                [pageSize]="pageSize"
                [pageSizeOptions]="[5, 10, 20]"
                showFirstLastButtons
                (page)="onPageChange($event)">
            </mat-paginator>
        </caption>
        <thead>
          <tr class="apps-table-header-layout apps-table-header-style">
            <th class="app-table-columns draft-app-table-form-type-col" mat-sort-header="form" sortActionDescription="Sort by Form Type"><span>Form</span></th>
            <th class="app-table-columns draft-app-table-names-col" mat-sort-header="suggestedNamesText" sortActionDescription="Sort by Suggested Names"><span>Suggested / Revised Names</span></th>
            <th class="app-table-columns draft-app-table-modified-col" mat-sort-header="modifiedDate" sortActionDescription="Sort by Date"><span>Modified Date</span></th>
            <th class="app-table-columns draft-app-table-progress-col"><span>Progress</span></th>
            <th class="app-table-columns draft-app-table-edit-col"><span>View / Edit</span></th> 
            <th class="app-table-columns draft-app-table-discard-col"><span>Discard</span></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let app of paginatedDrafts" class="apps-table-value-layout apps-table-value-style">
            <td class="app-table-columns draft-app-table-form-type-col draft-app-left-aligned">
               <span class="form-name-outer"><span style="padding-left: 15px;">{{ app.form }}</span></span>
            </td>
            <td class="app-table-columns draft-app-table-names-col draft-app-data-col">
              {{ app.suggestedNamesText }}
            </td>
            <td class="app-table-columns draft-app-table-modified-col draft-app-data-col">
              {{ app.modifiedDate }}
            </td>
            <td class="app-table-columns draft-app-table-progress-col padding-top-5">
              <span class="draft-app-table-progress-container">
                <mat-progress-spinner mode="determinate" [value]="100" [diameter]="24" [strokeWidth]="4"
                  class="draft-app-icon app-progress-icon draft-app-status-spinner-base"></mat-progress-spinner>
                <mat-progress-spinner mode="determinate" [value]="app.progressValue" [diameter]="24" [strokeWidth]="4"
                  class="draft-app-icon app-progress-icon draft-app-status-spinner-progress"></mat-progress-spinner>
              </span>
            </td>
            <td class="app-table-columns draft-app-table-edit-col padding-top-5">
              <button *ngIf="!isAppInfoModelLocked(app)" class="draft-app-btn" (click)="openDraftApplication(app)">
                <mat-icon class="draft-app-icon material-icons-outlined">edit</mat-icon>
              </button>
              <button *ngIf="isAppInfoModelLocked(app)" class="draft-app-btn" (click)="viewDraftApplication(app)">
                <mat-icon class="draft-app-icon material-icons-outlined" matTooltip="Read-only: Another user is currently editing the application">visibility</mat-icon>
              </button>
            </td>
            <td class="app-table-columns draft-app-table-discard-col padding-top-5">
              <button *ngIf="!isAppInfoModelLocked(app)" type="button" class="draft-delete-appl form-btn-text"
                (click)="openDialog(app)">
                <mat-icon class="draft-app-icon material-icons-outlined">delete</mat-icon>
              </button>
              <div *ngIf="isAppInfoModelLocked(app)" class="draft-delete-appl form-btn-text">
                <mat-icon class="draft-app-icon material-icons-outlined">lock</mat-icon>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>
  <ng-template #mobileDrafts>
    <div class="draft-applications-mobile">
          <mat-paginator
                [length]="totalItems"
                [pageSize]="pageSize"
                [pageSizeOptions]="[5, 10, 20]"
                 [showFirstLastButtons]="false"
                (page)="onPageChange($event)">
            </mat-paginator>
      <ng-container *ngFor="let app of paginatedDrafts">
        <div class="draft-app-mobile">
          <div class="draft-app-mobile-style">
            <div [ngClass]="isMobileDeviceSize ? 'draft-app-mobile-info__mobile' : 'draft-app-mobile-info__full'">
              <span class="draft-app-mobile-form-text">
                {{ app.formType }}
              </span>
              <span class="draft-app-mobile-details-text">
                {{ app.draftDetailsText }}
              </span>
            </div>
            <div class="draft-app-icon-list" [ngClass]="isMobileDeviceSize ? 'draft-app-icon-list__mobile' : 'draft-app-icon-list__full'">
              <span class="draft-app-mobile-progress-container">
                <mat-progress-spinner mode="determinate" [value]="100" [diameter]="24" [strokeWidth]="4"
                  class="draft-app-mobile-icon app-progress-icon draft-app-status-spinner-base "></mat-progress-spinner>
                <mat-progress-spinner mode="determinate" [value]="app.progressValue" [diameter]="24" [strokeWidth]="4"
                  class="draft-app-mobile-icon app-progress-icon draft-app-status-spinner-progress"></mat-progress-spinner>
              </span>
              <button *ngIf="!isAppInfoModelLocked(app)" class="draft-app-btn" (click)="openDraftApplication(app)">
                <mat-icon class="draft-app-mobile-icon material-icons-outlined">edit</mat-icon>
              </button>
              <button *ngIf="isAppInfoModelLocked(app)" class="draft-app-btn" (click)="viewDraftApplication(app)">
                <mat-icon class="draft-app-mobile-icon material-icons-outlined">visibility</mat-icon>
              </button>
              <button *ngIf="!isAppInfoModelLocked(app)" class="draft-app-btn" (click)="openDialog(app)">
                <mat-icon class="draft-app-mobile-icon material-icons-outlined">delete</mat-icon>
              </button>
              <div *ngIf="isAppInfoModelLocked(app)" class="draft-app-btn">
                <mat-icon class="draft-app-mobile-icon material-icons-outlined">lock</mat-icon>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-template>
</div>